import { Component, EventEmitter, Input, Output } from '@angular/core';
import { TableSummaryBarItemModel } from '../table-summary-bar.model';


@Component({
  selector: 'rnpl-table-summary-bar',
  templateUrl: './table-summary-bar.component.html',
  styleUrls: ['./table-summary-bar.component.scss']
})
export class TableSummaryBarComponent {

  @Input() tableSummaryBarItems: TableSummaryBarItemModel[] = [];
  @Input() hideSummary: boolean;
  // TODO: flat class added for new design wrapper until all pages done
  @Input() flat: boolean;

  @Output() itemClick = new EventEmitter<TableSummaryBarItemModel>();

  public isDisplayed(item: TableSummaryBarItemModel): boolean {
    if (item.hasOwnProperty('displayed')) {
      return item.displayed;
    }
    return true;
  }

}
